import { glSlotsMixin } from '~/lib/utils/vue3compat/gl_slots_mixin';
export default {
    name: 'VerificationLayout',
    mixins: [
        glSlotsMixin
    ],
    props: {
        svgPath: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: true
        }
    }
};
